import { Component, OnInit } from '@angular/core';

export interface WeekData {
  weekNumber: number;
  subjects: string[];
}

@Component({
    selector: 'app-eleven-topic-test',
    templateUrl: './eleven-topic-test.component.html',
    styleUrls: ['./eleven-topic-test.component.css'],
    standalone: false
})
export class ElevenTopicTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  weeks: WeekData[] = [
      {
        weekNumber: 1,
        subjects: [
          'Maths - Numbers & Factors (M01)',
          'English Reading Comprehension (ECOMP01)',
          'English Creative Writing (CW01)'
        ]
      },
      {
        weekNumber: 2,
        subjects: [
          'Maths - Decimals  (M02)',
          'English Reading Comprehension (ECOMP02)',
          'English Creative Writing  (CW02)'
        ]
      },
      {
        weekNumber: 3,
        subjects: [
          'Maths - Fractions (M03)',
          'English Creative Writing (CW03)',
          'Reasoning - Verbal & Non Verbal (VRNVR01)'
        ]
      },
      // Add more weeks as needed
      {
        weekNumber: 4,
        subjects: [
          'Maths - Percentage (M04)',
          'English Reading Comprehension (ECOMP03)',
          'English Creative Writing (CW04)'
        ]
      },
      {
        weekNumber: 5,
        subjects: [
          'Maths - Money (M05)',
          'English Reading Comprehension (ECOMP04)',
          'English Creative Writing (CW05)'
        ]
      },
      {
        weekNumber: 6,
        subjects: [
          'Maths - Data Handling (M06)',
          'English Creative Writing  (CW06)',
          'Reasoning - Verbal & Non Verbal (VRNVR02)'
        ]
      },
      {
        weekNumber: 7,
        subjects: [
         'Maths - Day Date Time (M07)',
          'English Reading Comprehension (ECOMP05)',
          'English Creative Writing (CW07)'
        ]
      },
      {
        weekNumber: 8,
        subjects: [
          'Maths - Probability, Ratio and Proportion (M08)',
          'English Reading Comprehension (ECOMP06)',
          'English Creative Writing (CW08)'
        ]
      },
      {
        weekNumber: 9,
        subjects: [
          'Maths - Shapes, Area, Perimeter & Volume Part 01 (M09)',
          'English Reading Comprehension (ECOMP07)',
          'English Creative Writing  (CW09)'
        ]
      },
      {
        weekNumber: 10,
        subjects: [
           'Maths - Algebra Part 01 (Basics) (M10)',
          'Creative Writing  (CW10)',
          'Reasoning - Verbal & Non Verbal (VRNVR03)'
        ]
      },
      {
        weekNumber: 11,
        subjects: [
          'Maths - Sequences, Distance, Speed, Time, Temperature  (M11)',
          'English Reading Comprehension (ECOMP08)',
          'English Creative Writing (CW11)'
        ]
      },
      {
        weekNumber: 12,
        subjects: [
          'Maths - Data Handling Part 02 (Advanced) (M12)',
          'English Creative Writing (CW12)',
          'Reasoning - Verbal & Non Verbal (VRNVR04)'
        ]
      },
      {
        weekNumber: 13,
        subjects: [
          'Maths - Shapes, Area, Perimeter & Volume Part 02 (Advanced) (M13)',
          'English Reading Comprehension (ECOMP09)',
          'English Creative Writing (CW13)'
        ]
      },
      {
        weekNumber: 14,
        subjects: [
          'Maths - Algebra Part 02 (Advanced) (M14)',
          'English Reading Comprehension (ECOMP10)',
          'English Creative Writing (CW14)'
        ]
      },
      {
        weekNumber: 15,
        subjects: [
          'Maths - ALL Topics (M15)',
          'English Creative Writing (CW15)',
          'Reasoning - Verbal & Non Verbal (VRNVR05)'
        ]
      }
    ];


  downloadCalendar() {
    window.location.href = " https://drive.google.com/uc?export=download&id=1iOO5PXJtTqgihbsgo1lRVciN7xufo4kO";
  }

}
